import { GetFilterResponse } from '@/modules/accredited-establishments/api/types'

const makeItems = (data: GetFilterResponse): GetFilterResponse => {
  return {
    ...data,
    items: [{ title: 'Todos os planos', value: 'ALL' }, ...data.items]
  }
}
export { makeItems }
